<template>
    <div data-name="interaction-layer-element-wrapper" :style="style">
        <slot />
    </div>
</template>

<script>
    import scaleProject from "@mixins/ScaleProject";

    export default {
        name: "InteractionLayerElement",
        props:{
            element:{},
            delay: {},
            show:{}
        },
        mixins:[
            scaleProject
        ],
        computed:{
            animation(){
                const animation = this.element.animation;
                const animationObj = window.element_animations[animation.name].anime;

                return {
                    targets: this.$el,
                    ...animationObj,
                    delay: animation.delay * 1000,
                    easing: animation.easing,
                    duration: (animation.duration * 1000)
                }
            },
            style(){
                return {
                    // ...this.scaledStyles,
                    position: 'absolute',
                    opacity: 0,
                    left: this.leftPosition,
                    top: this.topPosition,
                    height: this.height,
                    width: this.width,
                    willChange: 'transform, opacity',
                    zIndex: this.element.zIndex + 200, // Bump up the zindex's so they appear above the video
                    pointerEvents: 'none', // don't forget to cancel this in child so elemnts under can be clicked
                }
            },

            leftPosition(){
                return this.scaleValue(this.element.posX) + 'px';
            },

            topPosition(){
                return this.scaleValue(this.element.posY) + 'px';
            },

            height(){
                return this.element.height + 'px';
            },

            width(){
                return this.element.width + 'px';
            }
        },
        mounted(){
            this.$anime
                .timeline()
                .add(this.animation)

        },
        watch:{
            show(){
            }
        }
    }
</script>

<style scoped>

</style>